import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { ValidationService } from '../../../../shared/_services/validation.service';
import { RequestOptions, Response } from '@angular/http';
import { LoginService } from './../../../../shared/_services/login.service';
import { config } from '../../../../../providers/config';
import { UserManagementService } from '../../../../shared/_services/user-management.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ImageFile } from '../../../../shared/_data-model/image-file';
import { UtilService } from '../../../../shared/_services/util.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../modals/status-modal/status-modal.component';

@Component({
  selector: 'app-profile-management',
  templateUrl: './profile-management.component.html',
  styleUrls: ['./profile-management.component.scss']
})
export class ProfileManagementComponent implements OnInit {
  userInfo: any;
  errorDetails: any;
  newPswsReq: boolean;
  imageFile: ImageFile = new ImageFile;
  isDirty: boolean = false;
  imageUrl: any = '/assets/images/profile-default.svg';
  user: any = FormGroup;
  errorUpload: any;
  statusModal: BsModalRef;
  ProfileUpdateSuccessMsg:string;
  @ViewChild('uploadFile') uploadFile: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  fileSizeError: any;
  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private router: Router,
    private loginService: LoginService,
    private utilService: UtilService,
    private modalService: BsModalService,
    private validationService: ValidationService,
    private userManagementService: UserManagementService
  ) { 
    this.modalService.onHide
    .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.type == "hca-image") {
          if (this.statusModal.content.srcObject.action == "action1") {
            this.isDirty = true;
            if (this.statusModal.content.srcObject.image == 'logo') {
              // this.resetFileInput(this.uploadFile);
              this.imageFile = new ImageFile;
              this.user.get('isProfilePicUpdate').patchValue(true);
              console.log(this.imageFile);
            }
          }
        }
      }
    })
  }

  getProfiledetails() {
    this.userManagementService.getProfile(JSON.parse(localStorage.getItem('loggedInUser')).userId).subscribe(
      data => {
        if (data.error == 0) {
          console.log(data);
          this.user.patchValue(data.responseObj);
          this.imageFile.imageUrl = data.responseObj.profilePicture && data.responseObj.profilePicture.indexOf('/home/ubuntu') == -1 ? `${environment.BASE_IMAGE_API}/images/profile_pics/${JSON.parse(localStorage.getItem('loggedInUser')).userId}/${data.responseObj.profilePicture}` : ``;
          this.imageFile.name = data.responseObj.profilePicture && data.responseObj.profilePicture.indexOf('/home/ubuntu') == -1 ? data.responseObj.profilePicture.split('/').pop() : ``;
        } else {
        }

      }, error => {
        console.error(error);
      }
    )
  }

  errorLoading() {
    // this.imageFile.imageUrl = 'assets/images/profile-default.svg';
    this.imageFile.imageUrl = '';
  }

  ngOnInit() {
    this.userInfo = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')) : null;
    this.getProfiledetails();
    this.user = this.fb.group({
      email: [''],
      firstName: ['', Validators.required],
      lastName1: ['', Validators.required],
      // mobileNumber: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(12), Validators.pattern(this.validationService.phoneNumber_regexPattern)])],
      mobileNumber: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      oldPwd: [''],
      isProfilePicUpdate: [false],
      newPwd: [{ value: '', disabled: this.user.oldPwd != '' }, Validators.compose([Validators.required, Validators.pattern(this.validationService.password_regexPattern)])],
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  
  enablePassword(event: Event) {
    this.newPswsReq = false;
    const oldPwdCtrl = this.user.get('oldPwd');
    const newPwdCtrl = this.user.get('newPwd');

    if (oldPwdCtrl.value == "") {
      this.user.patchValue({newPwd: ""});
      newPwdCtrl.disable();
    }
    else {
      newPwdCtrl.enable();
    }
  }

  checkNull(event) {
    const newPwdCtrl = this.user.get('newPwd');
    this.newPswsReq = false;
    if(newPwdCtrl.value == '' || !this.user.value.newPwd) {
      this.newPswsReq = true;
    }
  }
  // fileChanged(event: any) {
  //   let image = URL.createObjectURL(event.target.files[0]);
  //   console.log('image:::++', image);
  //   let fileList: FileList = event.target.files;
  //   this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image); 
  //   //this.loginService.profileInfo(this.imageUrl);
  //   this.imageFile = event.target.files[0];
  //   this.errorUpload = false;
  //   if (fileList.length > 0 && (this.imageFile.type === 'image/png' || this.imageFile.type === 'image/jpg' || this.imageFile.type === 'image/jpeg')) {
  //     this.errorUpload = false;
  //   } else {
  //     this.errorUpload = true;
  //     console.log('Please upload Images only');
  //   }
  // }

  uploadImage(event: any, mode) {
    if (mode == "logo") {
      this.imageFile = this.utilService.uploadImage(event);
      this.errorUpload = this.imageFile.errorUpload;
      this.fileSizeError = this.imageFile.fileSizeError;
      setTimeout(() => {
        this.errorUpload = false;
        this.fileSizeError = false;
      }, 2000);
      if (this.errorUpload || this.fileSizeError) {
        this.imageFile.imageUrl = "";
      }
      this.resetFileInput('uploadFile');
    }
    this.user.get('isProfilePicUpdate').patchValue(true);
    this.isDirty = true;
  }

  deleteImage(mode) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      image: mode,
    }
  }

  resetFileInput(element?) {
    console.log(this[element].nativeElement.files);
    this[element].nativeElement.value = "";
    console.log(this[element].nativeElement.files);
  }

  saveUserInfo(data) {
    this.ProfileUpdateSuccessMsg = '';
    this.errorDetails = '';
    data.value.loyaltyUserId = JSON.parse(localStorage.getItem('loggedInUser')).userId;
    data.value.isProfilePicUpdate = data.value.isProfilePicUpdate ? true : false;
    let formData: any = new FormData()
    formData.append('user', JSON.stringify(data.value));
    if (this.imageFile && this.imageFile.file) {
      formData.append('profilePic', this.imageFile.file, this.imageFile.name ? this.imageFile.name : this.imageFile.file.name);
    } else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('profilePic', file, null);
      // formData.append('profilePic', null);
    }
    this.userManagementService.profileUpdate(formData, false).subscribe((res) => {
      if(res.error == 0) {
        if(res.responseObj) {
          var obj = JSON.parse(localStorage.getItem('loggedInUser'));
          obj['profilePic'] = res.responseObj.profilePicture;
          localStorage.setItem('loggedInUser', JSON.stringify(obj));
          this.loginService.profileInfo(this.imageFile.imageUrl);
        }
        this.ProfileUpdateSuccessMsg = 'Profile Updated Successfully';
        setTimeout(() => {
          this.ProfileUpdateSuccessMsg = '';
        }, 3000)
        // this.router.navigate(['/hca-management']);
      } else {
        this.errorDetails = res.message;
        setTimeout(() => {
          this.errorDetails = '';
        }, 3000)
      }
    }, error => {
      this.errorDetails = error.message;
      setTimeout(() => {
        this.errorDetails = '';
      }, 3000)
      console.log('========res ===========', error);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/profile-management/profile-management.component.ts